import styled from "styled-components";
import { Empty } from "antd-mobile";
import { Loading } from "react-vant";
import { useIntl } from "react-intl";
export default function List({
  wrap,
  list,
  header,
  loading = false,
  onClick = () => {},
  ...props
}) {
  const intl = useIntl()
  return (
    <>
      {loading ? (
        <Loading style={{ marginTop: "20vw" }} size="2.4rem" vertical>
          {intl.formatMessage({id:'common.loading',defaultMessage:'加載中...'})}
        </Loading>
      ) : list && list.length ? (
        <ListsWrapper {...props}>
          {list.map((e, i) => (
            <ListWrapper wrap={wrap} key={i} onClick={() => onClick(e)}>
              {header.map((h, hi) => (
                <div key={hi} style={{width: h.width}}>
                  {h.render ? h.render(e[h.prop], e) : e[h.prop]}
                </div>
              ))}
            </ListWrapper>
          ))}
        </ListsWrapper>
      ) : (
        <Empty description={
          intl.formatMessage({id:'common.no_data',defaultMessage:'暫無數據'})
        } imageStyle={{ width: 128 }} />
      )}
    </>
  );
}

const ListsWrapper = styled.div`
  border: 2px solid #000;
  border-radius: 2.2rem;
  box-shadow: 2px .25rem .0rem #000;
  overflow: hidden;
`;

const ListWrapper = styled.div`
  padding: 1.3rem 1.0rem;
  border-bottom: 1px solid #000;
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  align-items: center;
  flex-wrap: ${props => props.wrap ? 'wrap' : ''};
  &:last-child {
    border: none;
  }
  &:first-child {
    border-bottom: 1px solid #000;
  }
`;
